<template>
  <form-group v-bind="$attrs">
    <v-row v-if="isEdit">
      <input-radio
        id="input:indBloqueado"
        v-model="item.indBloqueado"
        :options="indBloqueadoOptions"
        label="Produto bloqueado"
        disabled
        row
      />
    </v-row>
    <v-row v-if="isEdit">
      <v-col cols="6">
        <input-date
          id="input:createdDate"
          v-model="item.createdDate"
          label="Data de criação"
          disabled
          outlined
        />
      </v-col>
      <v-col cols="6">
        <input-date
          id="input:updatedDate"
          v-model="item.updatedDate"
          label="Última atualização"
          disabled
          outlined
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <nome-produto
          :payload="item"
          :loading="isLoading"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <tipo-operacao
          :payload="item"
          :loading="isLoading"
        />
      </v-col>
      <v-col cols="6">
        <produto-categoria
          :payload="item"
          :loading="isLoading"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <observation-txt-area
          :payload="item"
          :loading="isLoading"
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import NomeProduto from '../inputs/NomeProduto.vue';
import TipoOperacao from '../inputs/TipoOperacao.vue';
import ProdutoCategoria from '../inputs/ProdutoCategoria.vue';
import ObservationTxtArea from '../inputs/ObservationTxtArea.vue';

export default {
  name: 'ProdutoInfo',
  components: {
    FormGroup,
    NomeProduto,
    TipoOperacao,
    ProdutoCategoria,
    ObservationTxtArea,
  },
  props: {
    payload: {
      type: Object,
      default() {
        return {
          indBloqueado: '',
          createdDate: '',
          updatedDate: '',
        };
      },
    },
  },
  data: () => ({
    indBloqueadoOptions: [
      {
        value: true,
        label: 'Sim',
      },
      {
        value: false,
        label: 'Não',
        color: 'primary',
      },
    ],
  }),
  computed: {
    isLoading() {
      return this.produto.loading;
    },
    isEdit() {
      return this.$route.params.id;
    },
    item() {
      return this.payload;
    },
  },
  inject: {
    produto: {
      default() {
        return {
          loading: false,
        };
      },
    },
  },
};
</script>
